import React from "react";
import LegalStrip from "./LegalStrip";

const formatLot = (lotAcres) => {
  if (lotAcres == null) return "—";
  return `${lotAcres} ac`;
};

const renderHeroValue = (display) => {
  if (typeof display !== "string") return display;
  return display.split(/(\$|K|M|-| of )/g).map((token, idx) => {
    if (token === "$" || token === "K" || token === "M" || token === "-" || token === " of ") {
      const styleProp = token === "-" || token === " of " ? { fontWeight: 700 } : undefined;
      return (
        <span key={idx} className="abr-unit" style={styleProp}>
          {token}
        </span>
      );
    }
    return <React.Fragment key={idx}>{token}</React.Fragment>;
  });
};

const HeroSection = ({ generatedAtDisplay, property, hero, agent }) => {
  const specs = property.specs || {};
  return (
    <section id="hero" className="abr-section abr-hero" aria-labelledby="abr-hero-title">
      <div className="abr-updated-badge">
        <span className="abr-pulse" aria-hidden="true" />
        Updated {generatedAtDisplay}
      </div>
      <div className="abr-hero-rule" />
      <h1 className="abr-hero-title" id="abr-hero-title">
        Active<br />Buyer <span className="abr-hero-em">Report.</span>
      </h1>
      <p className="abr-hero-tag">
        What active buyers searching <strong>{property.zip}</strong> are looking for, and how your home stacks up.
      </p>
      <div className="abr-hero-address">
        {property.addressLine1} &middot; {property.city}, {property.state} {property.zip}
      </div>

      <div className="abr-hero-strip" role="list">
        {hero.stats.map((stat, idx) => {
          const valueClass = `abr-hero-stat-value${stat.accent ? " is-accent" : ""}${stat.wordy ? " is-wordy" : ""}`;
          return (
            <div className="abr-hero-stat" role="listitem" key={idx}>
              <div className={valueClass}>{renderHeroValue(stat.valueDisplay)}</div>
              <div className="abr-hero-stat-label">{stat.label}</div>
            </div>
          );
        })}
      </div>

      <div className="abr-subject-row" style={{ display: "none" }} aria-hidden="true">
        <div>
          <div className="abr-subject-addr">
            {property.addressLine1}
          </div>
          <div className="abr-subject-sub">
            {property.city}, {property.state} {property.zip}
          </div>
        </div>
        <div className="abr-subject-specs">
          <div>
            <div className="abr-subject-spec-label">Beds</div>
            <div className="abr-subject-spec-value">{specs.beds}</div>
          </div>
          <div>
            <div className="abr-subject-spec-label">Baths</div>
            <div className="abr-subject-spec-value">{specs.baths}</div>
          </div>
          <div>
            <div className="abr-subject-spec-label">Sq Ft</div>
            <div className="abr-subject-spec-value">{specs.sqft && specs.sqft.toLocaleString()}</div>
          </div>
          <div>
            <div className="abr-subject-spec-label">Built</div>
            <div className="abr-subject-spec-value">{specs.yearBuilt}</div>
          </div>
          <div>
            <div className="abr-subject-spec-label">Lot</div>
            <div className="abr-subject-spec-value">{formatLot(specs.lotAcres)}</div>
          </div>
        </div>
      </div>

      <LegalStrip agent={agent} />
    </section>
  );
};

export default HeroSection;
